import {Component, OnInit} from '@angular/core';
import {ConnectionService} from 'ng-connection-service';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';
  status = 'ONLINE';
  isConnected = true;
  blocked: boolean;

  constructor(private connectionService: ConnectionService, private router: Router) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = 'ONLINE';
      } else {
        this.status = 'Vous êtes offline';
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        console.log('RouteConfigLoadStart');
        this.blocked = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        console.log('RouteConfigLoadEnd');
        this.blocked = false;
      }
    });
  }
  ngOnInit(): void {}

}
